import { render } from "./WealthReportForm.vue?vue&type=template&id=b1829f98&scoped=true"
import script from "./WealthReportForm.vue?vue&type=script&lang=js"
export * from "./WealthReportForm.vue?vue&type=script&lang=js"

import "./WealthReportForm.vue?vue&type=style&index=0&id=b1829f98&lang=css"
import "./WealthReportForm.vue?vue&type=style&index=1&id=b1829f98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1829f98"]])

export default __exports__